import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import { applicantStatusMasters, folioTypeMaster, yesAndNoMasters1 } from '../../utils/constant';
import { getModeOfHolding } from '../../utils/utilityFunctions';
import { styles } from '../../Styles/styles';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  descriptionSx = {},
}: {
  title: string | undefined;
  description?: string[] | string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  descriptionSx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails sx={descriptionSx}>
        {' '}
        {description || description === 0 ? description : '-'}
      </ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  applicants = [],
  modeOfHolding,
  folioType,
  isTopup,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
  folioType: string;
  isTopup: boolean;
}): JSX.Element {
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {getModeOfHolding(modeOfHolding)}
                </Typography>
              </Typography>
              {/* <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Folio Type:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                  }}>
                  {folioType ? folioTypeMaster[folioType] : 'N/A'}
                </Typography>
              </Typography> */}
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'Primary Contributor Details',
                'Joint Contributor 1 Details',
                'Joint Contributor 2 Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles sx={{ width: '100%' }}>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      {!isTopup && (
                        <>
                          <KeyValue title={'Gender'} description={applicant.gender} />
                          <KeyValue
                            title={'Date Of Birth'}
                            description={formatShortDate(applicant.dateOfBirth)}
                          />
                          <KeyValue
                            title={'Father/Spouse Name'}
                            description={applicant.fatherOrSpouseName}
                          />
                          <KeyValue title={'Mother Name'} description={applicant.motherName} />
                          <KeyValue
                            title={'Wedding Anniversary'}
                            description={formatShortDate(applicant.weddingAnniversaryDate)}
                          />
                        </>
                      )}
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {!isTopup && (
                        <>
                          <KeyValue
                            title={'Status'}
                            description={
                              applicant.status
                                ? applicantStatusMasters[applicant.status]
                                : applicant.status
                            }
                          />
                          {applicant.status && applicant.status === 'NRI' && (
                            <>
                              <KeyValue
                                title={'Passport Number'}
                                description={applicant.passportNumber}
                              />
                              <KeyValue
                                title={'Passport Expiry Date'}
                                description={formatShortDate(applicant.passportExpiryDate)}
                              />
                            </>
                          )}

                          <KeyValue title={'Nationality'} description={applicant.nationality} />
                          {/* <KeyValue title={'LEI Number'} description={applicant.leiNumber} />
                      <KeyValue
                        title={'LEI Expiry Date'}
                        description={formatShortDate(applicant.leiExpiry)}
                      /> */}
                          <KeyValue
                            title={'Physical Communication'}
                            description={yesAndNoMasters1[applicant.physicalCommunication || '']}
                          />
                          {index !== 0 && (
                            <KeyValue
                              title={'RelationShip With Primary Contributor'}
                              description={applicant.relationShipWithFirstApplicant}
                            />
                          )}
                        </>
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
